import React, { useRef } from "react";
import { Button, ButtonProps } from "./Button";

export type FileButtonProps = Omit<ButtonProps, "onClick" | "type"> & {
  /** Files were picked (the input is reset after, so the same file can be picked again) */
  onFiles: (files: FileList) => void;
  accept?: string;
  multiple?: boolean;
};

/** A kit button that opens the file chooser — the page never shows the browser's own file input. */
export function FileButton({ onFiles, accept, multiple = false, disabled, children, ...rest }: FileButtonProps) {
  const input = useRef<HTMLInputElement>(null);
  return (
    <>
      <Button {...rest} disabled={disabled} onClick={() => input.current?.click()}>
        {children}
      </Button>
      <input
        ref={input}
        type="file"
        hidden
        accept={accept}
        multiple={multiple}
        disabled={disabled}
        onChange={(e) => {
          if (e.target.files && e.target.files.length > 0) onFiles(e.target.files);
          e.target.value = "";
        }}
      />
    </>
  );
}

export default FileButton;
